/* Store Legend — script del tema */
(function () {
  'use strict';

  var L = window.Legend || {};
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function formatMoney(cents) {
    var fmt = L.moneyFormat || '€{{amount_with_comma_separator}}';
    var value = (Number(cents) || 0) / 100;
    function fmtNum(n, decimals, thousands, decimal) {
      var parts = n.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount': return fmtNum(value, 2, ',', '.');
        case 'amount_no_decimals': return fmtNum(value, 0, ',', '.');
        case 'amount_no_decimals_with_comma_separator': return fmtNum(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmtNum(value, 2, "'", '.');
        default: return fmtNum(value, 2, '.', ',');
      }
    });
  }

  /* ---------- Toast ---------- */
  var toastTimer;
  function toast(msg, isError) {
    var el = $('#toast');
    if (!el) return;
    el.textContent = msg;
    el.classList.toggle('is-error', !!isError);
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 2600);
  }

  /* ---------- Overlay (menu, ricerca, carrello) ---------- */
  var openOverlay = null;
  var lastFocus = null;
  function open(name) {
    var el = $('[data-overlay="' + name + '"]');
    if (!el) return false;
    if (openOverlay && openOverlay !== el) close();
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    openOverlay = el;
    if (name === 'search') setTimeout(function () { var i = $('[data-search-input]'); if (i) i.focus(); }, 60);
    else { var c = $('[data-close]', el); if (c) c.focus({ preventScroll: true }); }
    if (name === 'cart') refreshCart();
    return true;
  }
  function close() {
    if (!openOverlay) return;
    openOverlay.classList.remove('is-open');
    openOverlay.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    openOverlay = null;
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-open]');
    if (opener) {
      if (open(opener.getAttribute('data-open'))) e.preventDefault();
      return;
    }
    if (e.target.closest('[data-close]')) { close(); return; }
    if (e.target.classList && e.target.classList.contains('overlay')) close();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  /* ---------- Carrello ---------- */
  var crossSell = [];
  try { crossSell = JSON.parse(($('#cross-sell-data') || {}).textContent || '[]'); } catch (err) { crossSell = []; }

  function setCount(n) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = n; });
    $$('[data-cart-count-label]').forEach(function (el) { el.textContent = '(' + n + ')'; });
  }

  function bundleHtml(count) {
    var msg;
    if (count < 2) msg = 'Aggiungi ancora ' + (2 - count) + ' capo e risparmi il <b>10%</b>';
    else if (count === 2) msg = 'Bundle <b>-10%</b> attivo · aggiungi 1 capo per il <b>-15%</b>';
    else msg = 'Bundle <b>-15%</b> attivo sul tuo ordine';
    var pct = Math.min(count / 3, 1) * 100;
    return '<span class="label-ui">' + msg + '</span><div class="bundle-progress__bar"><span style="width:' + pct + '%"></span></div>';
  }

  function renderCart(cart) {
    var body = $('[data-cart-body]');
    var foot = $('[data-cart-foot]');
    if (!body) return;
    setCount(cart.item_count);
    if (!cart.items.length) {
      body.innerHTML = '<div class="cart-empty"><p>Il carrello è vuoto.</p><a href="' + (L.routes.root || '/') + '#shop" class="btn btn--ink" data-close>Scegli i tuoi capi</a></div>' + crossSellHtml(cart);
      foot.hidden = true;
      return;
    }
    var html = cart.items.map(function (item) {
      var img = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '$1$2') : '';
      var variant = item.product_has_only_default_variant ? '' : '<p class="cart-line__variant">' + esc(item.variant_title || '') + '</p>';
      var strike = item.original_line_price > item.final_line_price ? '<s>' + formatMoney(item.original_line_price) + '</s>' : '';
      return '<div class="cart-line" data-line-key="' + esc(item.key) + '">' +
        '<a href="' + esc(item.url) + '" class="cart-line__img">' + (img ? '<img src="' + esc(img) + (img.indexOf('?') > -1 ? '&' : '?') + 'width=200" alt="' + esc(item.product_title) + '" loading="lazy">' : '') + '</a>' +
        '<div><a href="' + esc(item.url) + '" class="cart-line__title">' + esc(item.product_title) + '</a>' + variant +
        '<div class="cart-line__row"><div class="qty qty--sm"><button type="button" aria-label="Riduci quantità" data-line-qty="' + (item.quantity - 1) + '">–</button><span>' + item.quantity + '</span><button type="button" aria-label="Aumenta quantità" data-line-qty="' + (item.quantity + 1) + '">+</button></div>' +
        '<span class="cart-line__price">' + formatMoney(item.final_line_price) + strike + '</span></div>' +
        '<button type="button" class="cart-line__remove" data-line-qty="0" style="margin-top:8px">Rimuovi</button></div></div>';
    }).join('');
    body.innerHTML = html + crossSellHtml(cart);
    foot.hidden = false;

    $('[data-bundle-progress]').innerHTML = bundleHtml(cart.item_count);
    $('[data-cart-subtotal]').textContent = formatMoney(cart.original_total_price);
    var saving = cart.original_total_price - cart.total_price;
    var savingRow = $('[data-cart-saving-row]');
    if (saving > 0) {
      var titles = [];
      (cart.cart_level_discount_applications || []).forEach(function (d) { if (d.title && titles.indexOf(d.title) === -1) titles.push(d.title); });
      cart.items.forEach(function (it) { (it.discounts || []).forEach(function (d) { if (d.title && titles.indexOf(d.title) === -1) titles.push(d.title); }); });
      $('[data-cart-saving-label]').textContent = titles.length ? titles.join(' + ') : 'Sconto';
      $('[data-cart-saving]').textContent = '−' + formatMoney(saving);
      savingRow.hidden = false;
    } else {
      savingRow.hidden = true;
    }
    $('[data-cart-total]').textContent = formatMoney(cart.total_price);
  }

  function crossSellHtml(cart) {
    var inCart = cart.items.map(function (i) { return i.product_id; });
    var picks = crossSell.filter(function (p) { return inCart.indexOf(p.id) === -1; }).slice(0, 2);
    if (!picks.length) return '';
    return '<div class="cross-sell"><span class="label-ui eyebrow">Completa il look</span><div class="cross-sell__grid">' +
      picks.map(function (p) {
        return '<a class="cross-sell__item" href="' + esc(p.url) + '"><div class="tile"><img src="' + esc(p.image) + '" alt="' + esc(p.title) + '" loading="lazy"></div><strong>' + esc(p.title) + '</strong><span>' + esc(p.price) + '</span></a>';
      }).join('') + '</div></div>';
  }

  function refreshCart() {
    return fetch(L.routes.cart, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; })
      .catch(function () {});
  }

  function changeLine(key, qty) {
    var body = $('[data-cart-body]');
    if (body) body.style.opacity = '.5';
    return fetch(L.routes.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart.status && cart.description) toast(cart.description, true);
        else renderCart(cart);
      })
      .finally(function () { if (body) body.style.opacity = ''; });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-line-qty]');
    if (!btn) return;
    var line = btn.closest('[data-line-key]');
    if (line) changeLine(line.getAttribute('data-line-key'), Number(btn.getAttribute('data-line-qty')));
  });

  function addToCart(variantId, qty) {
    return fetch(L.routes.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty }] })
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw new Error(data.description || data.message || 'Impossibile aggiungere al carrello');
        return data;
      });
    });
  }

  /* ---------- Pagina prodotto ---------- */
  function initProduct(root) {
    var data;
    try { data = JSON.parse($('[data-product-json]', root).textContent); } catch (err) { return; }
    var form = $('[data-product-form]', root);
    var idInput = $('[data-variant-id]', root);
    var options = $('[data-options]', root);
    var qtyInput = $('[data-qty-input]', root);
    var selected = data.variants.filter(function (v) { return String(v.id) === idInput.value; })[0] || data.variants[0];
    var current = selected.options.slice();

    function findVariant(opts) {
      return data.variants.filter(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      })[0];
    }

    function updateButtons() {
      $$('.opt-btn', root).forEach(function (btn) {
        var idx = Number(btn.getAttribute('data-option-index'));
        var val = btn.getAttribute('data-value');
        var isSel = current[idx] === val;
        btn.classList.toggle('is-selected', isSel);
        btn.setAttribute('aria-pressed', isSel ? 'true' : 'false');
        var test = current.slice(); test[idx] = val;
        var v = findVariant(test);
        btn.classList.toggle('is-unavailable', !v || !v.available);
      });
      $$('[data-option-label]', root).forEach(function (el) {
        el.textContent = current[Number(el.getAttribute('data-option-label'))] || '';
      });
    }

    function applyVariant(v) {
      selected = v;
      if (!v) {
        $$('[data-add], [data-add-proxy], [data-buy-now]', root).forEach(function (b) { b.disabled = true; });
        $$('[data-add], [data-add-proxy]', root).forEach(function (b) { b.textContent = 'Non disponibile'; });
        return;
      }
      idInput.value = v.id;
      $$('[data-price]', root).forEach(function (el) { el.textContent = v.price; el.classList.toggle('is-sale', v.pct > 0); });
      $$('[data-compare]', root).forEach(function (el) { el.textContent = v.compare || ''; el.hidden = !v.compare; });
      var pct = $('[data-pct]', root);
      if (pct) { pct.textContent = '-' + v.pct + '%'; pct.hidden = !v.pct; }
      $$('[data-add], [data-add-proxy]', root).forEach(function (b) { b.disabled = !v.available; b.textContent = v.available ? 'Acquista' : 'Esaurito'; });
      $$('[data-buy-now]', root).forEach(function (b) { b.disabled = !v.available; });
      if (v.media) goToMedia(v.media);
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    if (options) {
      options.addEventListener('click', function (e) {
        var btn = e.target.closest('.opt-btn');
        if (!btn) return;
        current[Number(btn.getAttribute('data-option-index'))] = btn.getAttribute('data-value');
        var v = findVariant(current);
        updateButtons();
        applyVariant(v);
      });
      updateButtons();
    }

    // Quantità
    var minus = $('[data-qty-minus]', root), plus = $('[data-qty-plus]', root);
    if (minus) minus.addEventListener('click', function () { qtyInput.value = Math.max(1, Number(qtyInput.value) - 1); });
    if (plus) plus.addEventListener('click', function () { qtyInput.value = Math.min(5, Number(qtyInput.value) + 1); });

    function requireVariant() {
      if (selected && selected.available) return true;
      if (options) {
        options.classList.add('is-highlight');
        options.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
        setTimeout(function () { options.classList.remove('is-highlight'); }, 2000);
      }
      toast('Scegli una taglia disponibile', true);
      return false;
    }

    function setLoading(on) {
      $$('[data-add], [data-add-proxy], [data-buy-now]', root).forEach(function (b) { b.disabled = on || !(selected && selected.available); });
    }

    function handleAdd(e) {
      if (e) e.preventDefault();
      if (!requireVariant()) return;
      setLoading(true);
      addToCart(selected.id, Number(qtyInput.value) || 1)
        .then(function () { toast('Aggiunto al carrello'); open('cart'); })
        .catch(function (err) { toast(err.message, true); })
        .finally(function () { setLoading(false); });
    }

    form.addEventListener('submit', handleAdd);
    $$('[data-add-proxy]', root).forEach(function (b) { b.addEventListener('click', handleAdd); });
    $$('[data-buy-now]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        if (!requireVariant()) return;
        setLoading(true);
        addToCart(selected.id, Number(qtyInput.value) || 1)
          .then(function () { window.location.href = '/checkout'; })
          .catch(function (err) { toast(err.message, true); setLoading(false); });
      });
    });

    // Barra mobile
    var bar = $('[data-mobile-bar]', root);
    var box = $('[data-buybox]', root);
    if (bar && box && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var show = !en.isIntersecting && en.boundingClientRect.top < 0;
          bar.classList.toggle('is-visible', show);
          bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        });
      }).observe(box);
    }

    // Galleria
    var track = $('[data-gallery-track]', root);
    var slides = track ? $$('.gallery__slide', track) : [];
    function goTo(i) {
      if (!track || !slides.length) return;
      i = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[i].offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
    }
    function goToMedia(id) {
      slides.forEach(function (s, i) { if (s.getAttribute('data-media-id') === String(id)) goTo(i); });
    }
    function currentIndex() {
      if (!track) return 0;
      return Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
    }
    if (track) {
      var prev = $('[data-gallery-prev]', root), next = $('[data-gallery-next]', root);
      if (prev) prev.addEventListener('click', function () { goTo(currentIndex() - 1); });
      if (next) next.addEventListener('click', function () { goTo(currentIndex() + 1); });
      $$('[data-gallery-dot], [data-gallery-thumb]', root).forEach(function (b) {
        b.addEventListener('click', function () { goTo(Number(b.getAttribute('data-gallery-dot') || b.getAttribute('data-gallery-thumb'))); });
      });
      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          var i = currentIndex();
          $$('[data-gallery-dot]', root).forEach(function (d, j) { d.classList.toggle('is-active', i === j); });
          $$('[data-gallery-thumb]', root).forEach(function (d, j) { d.classList.toggle('is-active', i === j); });
          ticking = false;
        });
      });
    }
  }

  /* ---------- Descrizione → Il capo / Guida taglie / Indossata da ---------- */
  var CUT = ['ci hanno scelti', 'guida alle taglie', 'size guide', 'il regalo perfetto', 'i tempi di consegna', 'il codice di tracciamento'];
  var EXCLUDED_IMG = ['screenshot', 'aggiungi_un_sottotitolo'];

  function trimSegment(text) {
    var out = text;
    var bang = out.indexOf('!');
    if (bang !== -1) out = out.slice(0, bang);
    var low = out.toLowerCase();
    CUT.forEach(function (m) { var i = low.indexOf(m); if (i !== -1) { out = out.slice(0, i); low = out.toLowerCase(); } });
    return out.trim();
  }

  function parseDescription(html) {
    var doc = new DOMParser().parseFromString('<div>' + html + '</div>', 'text/html');
    var rootEl = doc.body.firstChild;
    var table = rootEl.querySelector('table');
    var sizeTable = null;
    if (table) {
      var rows = $$('tr', table).map(function (tr) { return $$('td,th', tr).map(function (c) { return c.textContent.replace(/\s+/g, ' ').trim(); }); });
      if (rows.length > 1) {
        var headerRow = rows[0].slice(1).filter(Boolean);
        var unit = headerRow.join(' ').toLowerCase().indexOf('inch') > -1 ? 'in' : 'cm';
        var dataRows = rows.slice(1).map(function (cells) {
          return { size: cells[0], values: cells.slice(1).map(function (v) { return Number(v.replace(',', '.')); }).filter(function (n) { return isFinite(n) && !isNaN(n); }) };
        }).filter(function (r) { return r.size && r.values.length; });
        if (headerRow.length && dataRows.length) {
          sizeTable = { unit: unit, headers: headerRow.map(function (h) { return h.replace(/\((inches|cm)\)/gi, '').trim(); }), rows: dataRows };
        }
      }
      var wrapper = table.closest('.table-responsive') || table;
      wrapper.remove();
    }
    var images = $$('img', rootEl).map(function (img) { return img.getAttribute('src'); }).filter(function (src) {
      return src && !EXCLUDED_IMG.some(function (p) { return src.toLowerCase().indexOf(p) > -1; });
    });
    $$('h1,h2,h3', rootEl).forEach(function (h) { h.remove(); });
    var text = rootEl.innerHTML
      .replace(/<(br|\/p|\/div|\/h\d|\/li)[^>]*>/gi, '\n')
      .replace(/<[^>]*>/g, '');
    var tmp = document.createElement('textarea');
    tmp.innerHTML = text;
    var lines = tmp.value.split('\n').map(function (l) { return l.replace(/\s+/g, ' ').trim(); }).filter(Boolean)
      .filter(function (l) { var low = l.toLowerCase(); return !CUT.some(function (m) { return low.indexOf(m) > -1; }); });
    var bullets = [], intro = [];
    lines.forEach(function (line) {
      if (line.indexOf('•') === 0) {
        line.split('•').map(function (p) { return p.trim(); }).filter(Boolean).forEach(function (p) { bullets.push(p); });
      } else if (!bullets.length) {
        intro.push(line);
      }
    });
    return {
      intro: trimSegment(intro.join(' ')),
      bullets: bullets.map(trimSegment).filter(Boolean),
      sizeTable: sizeTable,
      images: images
    };
  }

  function toCm(inches) { return Math.round(inches * 2.54 * 2) / 2; }
  function toInches(cm) { return Math.round((cm / 2.54) * 2) / 2; }

  function initDescription() {
    var src = $('[data-description-source]');
    var target = $('[data-description-target]');
    if (!src || !target) return;
    var parsed = parseDescription(src.innerHTML);
    var html = '';
    if (parsed.intro || parsed.bullets.length) {
      html += '<section class="p-block reveal"><div class="p-block__inner p-block__inner--top"><h2>Il capo</h2>' +
        (parsed.intro ? '<p class="p-intro">' + esc(parsed.intro) + '</p>' : '') +
        (parsed.bullets.length ? '<ul class="p-bullets">' + parsed.bullets.map(function (b) { return '<li><span>' + esc(b) + '</span></li>'; }).join('') + '</ul>' : '') +
        '</div></section>';
    }
    if (parsed.sizeTable) {
      html += '<section id="guida-taglie" class="p-block reveal" style="scroll-margin-top:120px"><div class="p-block__inner"><div class="size-head"><h2>Guida alle taglie</h2>' +
        '<div class="unit-toggle" role="group" aria-label="Unità di misura"><button type="button" class="is-active" data-unit="cm">cm</button><button type="button" data-unit="in">pollici</button></div></div>' +
        '<div class="size-table-wrap"><table class="size-table"><thead><tr><th>Taglia</th>' +
        parsed.sizeTable.headers.map(function (h) { return '<th>' + esc(h) + '</th>'; }).join('') +
        '</tr></thead><tbody data-size-body></tbody></table></div><p class="size-note">Misure del capo steso. In caso di dubbio scegli la taglia più grande.</p></div></section>';
    }
    if (parsed.images.length) {
      var shown = parsed.images.slice(0, 4);
      html += '<section class="p-block reveal"><div class="p-block__inner"><h2>Indossata da</h2><div class="worn-grid' + (shown.length > 2 ? ' is-4' : '') + '">' +
        shown.map(function (s) { return '<div><img src="' + esc(s) + '" alt="" loading="lazy"></div>'; }).join('') + '</div></div></section>';
    }
    target.innerHTML = html;

    if (parsed.sizeTable) {
      var t = parsed.sizeTable;
      var bodyEl = $('[data-size-body]', target);
      var renderTable = function (unit) {
        bodyEl.innerHTML = t.rows.map(function (row) {
          return '<tr><td>' + esc(row.size) + '</td>' + row.values.map(function (v) {
            var out = t.unit === 'in' ? (unit === 'in' ? v + '"' : toCm(v) + ' cm') : (unit === 'cm' ? v + ' cm' : toInches(v) + '"');
            return '<td>' + out + '</td>';
          }).join('') + '</tr>';
        }).join('');
      };
      renderTable('cm');
      $$('[data-unit]', target).forEach(function (b) {
        b.addEventListener('click', function () {
          $$('[data-unit]', target).forEach(function (x) { x.classList.toggle('is-active', x === b); });
          renderTable(b.getAttribute('data-unit'));
        });
      });
    }
  }

  /* ---------- Hero a rotazione ---------- */
  function initHero(hero) {
    var quotes;
    try { quotes = JSON.parse($('[data-hero-data]', hero).textContent); } catch (err) { return; }
    var qEl = $('[data-hero-quote]', hero), aEl = $('[data-hero-author]', hero), mEl = $('[data-hero-mark]', hero);
    var dots = $$('[data-hero-dot]', hero);
    var i = 0, timer = null, paused = false;

    function show(n) {
      i = (n + quotes.length) % quotes.length;
      var q = quotes[i];
      var words = ('«' + q.quote + '»').split(' ');
      qEl.classList.remove('is-in');
      qEl.classList.toggle('is-long', q.quote.length > 24);
      qEl.innerHTML = words.map(function (w, k) {
        return '<span class="hero__word"><span style="transition-delay:' + (k * 0.07) + 's">' + esc(w) + '</span></span>';
      }).join('');
      aEl.classList.remove('is-in');
      aEl.textContent = q.author + (q.year ? ' · ' + q.year : '');
      aEl.style.transitionDelay = (words.length * 0.07 + 0.15) + 's';
      if (mEl) {
        mEl.classList.add('is-out');
        setTimeout(function () { mEl.textContent = q.mark || q.year || ''; mEl.classList.remove('is-out'); }, reduceMotion ? 0 : 250);
      }
      dots.forEach(function (d, k) {
        d.classList.toggle('is-active', k === i);
        d.setAttribute('aria-selected', k === i ? 'true' : 'false');
        var bar = d.firstElementChild;
        if (bar) { var clone = bar.cloneNode(); d.replaceChild(clone, bar); }
      });
      requestAnimationFrame(function () { requestAnimationFrame(function () { qEl.classList.add('is-in'); aEl.classList.add('is-in'); }); });
    }
    function start() {
      stop();
      if (reduceMotion || quotes.length < 2) return;
      timer = setInterval(function () { if (!paused) show(i + 1); }, 5000);
    }
    function stop() { if (timer) clearInterval(timer); timer = null; }

    hero.addEventListener('mouseenter', function () { paused = true; hero.classList.add('is-paused'); });
    hero.addEventListener('mouseleave', function () { paused = false; hero.classList.remove('is-paused'); });
    dots.forEach(function (d) { d.addEventListener('click', function () { show(Number(d.getAttribute('data-hero-dot'))); start(); }); });
    show(0);
    start();
  }

  /* ---------- Archivio + filtri home ---------- */
  var FILTERS = ['tutti', 'felpe', 'felpe-cappuccio', 'felpe-girocollo', 'magliette', 'italiani', 'internazionali'];
  function matches(card, filter) {
    var g = card.getAttribute('data-garment'), era = card.getAttribute('data-era');
    switch (filter) {
      case 'felpe': return g !== 'tshirt';
      case 'felpe-cappuccio': return g === 'cappuccio';
      case 'felpe-girocollo': return g === 'girocollo';
      case 'magliette': return g === 'tshirt';
      case 'italiani': return era === 'italiani';
      case 'internazionali': return era === 'internazionali';
      default: return true;
    }
  }

  function initArchive(section) {
    var items = $$('[data-archive-item]', section);
    var countEl = $('[data-archive-count]', section);
    var emptyEl = $('[data-archive-empty]', section);
    var clearFig = $('[data-clear-figure]', section);
    var state = { filter: 'tutti', figure: null, figureName: '' };

    function apply(animate) {
      var shown = 0;
      items.forEach(function (it, idx) {
        var card = $('[data-card]', it);
        var ok = matches(card, state.filter) && (!state.figure || card.getAttribute('data-figure') === state.figure);
        var wasHidden = it.hidden;
        it.hidden = !ok;
        if (ok) {
          shown++;
          if (animate && wasHidden && !reduceMotion) {
            it.classList.add('is-entering');
            setTimeout(function () { it.classList.remove('is-entering'); }, 20 + Math.min(idx, 7) * 30);
          }
        }
      });
      countEl.textContent = shown;
      emptyEl.hidden = shown > 0;
      $$('[data-filter]', section).forEach(function (t) {
        var on = t.getAttribute('data-filter') === state.filter;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      if (clearFig) { clearFig.hidden = !state.figure; clearFig.textContent = state.figureName + ' ×'; }
      $$('[data-figure-chip]').forEach(function (c) {
        var on = c.getAttribute('data-figure-chip') === state.figure;
        c.classList.toggle('is-active', on);
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    function setFilter(f, scroll) {
      state.filter = FILTERS.indexOf(f) > -1 ? f : 'tutti';
      apply(true);
      var url = new URL(window.location.href);
      if (state.filter === 'tutti') url.searchParams.delete('filter'); else url.searchParams.set('filter', state.filter);
      url.hash = 'shop';
      window.history.replaceState({}, '', url.toString());
      if (scroll) section.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    }

    $$('[data-filter]', section).forEach(function (t) {
      t.addEventListener('click', function () { setFilter(t.getAttribute('data-filter'), false); });
    });
    if (clearFig) clearFig.addEventListener('click', function () { state.figure = null; apply(true); });

    document.addEventListener('click', function (e) {
      var link = e.target.closest('[data-filter-link]');
      if (link) {
        e.preventDefault();
        close();
        setFilter(link.getAttribute('data-filter-link'), true);
        return;
      }
      var chip = e.target.closest('[data-figure-chip]');
      if (chip) {
        var h = chip.getAttribute('data-figure-chip');
        state.figure = state.figure === h ? null : h;
        state.figureName = chip.getAttribute('data-figure-name');
        setFilter('tutti', !!state.figure);
      }
    });

    var initial = new URL(window.location.href).searchParams.get('filter');
    if (initial && FILTERS.indexOf(initial) > -1) { state.filter = initial; }
    apply(false);
  }

  /* ---------- Timeline citazioni ---------- */
  function initTimeline(root) {
    var tabs = $$('[data-era-filter]', root);
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        var era = t.getAttribute('data-era-filter');
        tabs.forEach(function (x) { var on = x === t; x.classList.toggle('is-active', on); x.setAttribute('aria-pressed', on ? 'true' : 'false'); });
        $$('.timeline__item', root).forEach(function (li) { li.hidden = era !== 'tutti' && li.getAttribute('data-era') !== era; });
      });
    });
  }

  /* ---------- Ricerca ---------- */
  function initSearch() {
    var input = $('[data-search-input]');
    var out = $('[data-search-results]');
    if (!input || !out) return;
    var index = [];
    try { index = JSON.parse(($('#search-index') || {}).textContent || '[]'); } catch (err) { index = []; }
    input.addEventListener('input', function () {
      var term = input.value.trim().toLowerCase();
      if (!term) { out.innerHTML = ''; return; }
      var res = index.filter(function (p) {
        return p.title.toLowerCase().indexOf(term) > -1 || (p.name || '').toLowerCase().indexOf(term) > -1 || (p.quote || '').toLowerCase().indexOf(term) > -1;
      }).slice(0, 8);
      if (!res.length) { out.innerHTML = '<p class="text-muted" style="padding:24px 0;font-size:14px">Nessun risultato.</p>'; return; }
      out.innerHTML = res.map(function (p) {
        return '<a class="search-result" href="' + esc(p.url) + '"><span class="search-result__img">' + (p.image ? '<img src="' + esc(p.image) + '" alt="" loading="lazy">' : '') + '</span><span class="search-result__text"><strong>' + esc(p.title) + '</strong><span>' + (p.quote ? '«' + esc(p.quote) + '»' : '') + '</span></span></a>';
      }).join('');
    });
  }

  /* ---------- Varie ---------- */
  function initCarousels() {
    $$('[data-scroll-carousel]').forEach(function (b) {
      b.addEventListener('click', function () {
        var sec = b.closest('section');
        var c = sec && $('[data-carousel]', sec);
        if (c) c.scrollBy({ left: Number(b.getAttribute('data-scroll-carousel')) * c.clientWidth * 0.8, behavior: reduceMotion ? 'auto' : 'smooth' });
      });
    });
    $$('[data-scroll-to]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var t = document.getElementById(a.getAttribute('data-scroll-to'));
        if (!t) return;
        e.preventDefault();
        t.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      });
    });
  }

  function initReveal() {
    var els = $$('.reveal');
    if (!('IntersectionObserver' in window) || reduceMotion) { els.forEach(function (el) { el.classList.add('is-visible'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  document.addEventListener('DOMContentLoaded', function () {
    // logo: ingresso animato una volta per sessione
    var logo = $('.site-header__logo');
    if (logo && !reduceMotion) {
      var seen = false;
      try { seen = sessionStorage.getItem('sl-intro') === '1'; sessionStorage.setItem('sl-intro', '1'); } catch (e) {}
      if (!seen) logo.classList.add('is-intro');
    }
    $$('[data-hero]').forEach(initHero);
    $$('[data-product]').forEach(initProduct);
    initDescription();
    $$('[data-archive]').forEach(initArchive);
    $$('[data-timeline]').forEach(initTimeline);
    initSearch();
    initCarousels();
    initReveal();
    if (window.location.hash === '#shop' && $('#shop')) setTimeout(function () { $('#shop').scrollIntoView(); }, 50);
  });

  // Aggiorna il conteggio se il carrello cambia altrove (es. app)
  document.addEventListener('cart:refresh', refreshCart);
})();
